<template>
	<div class="relative w-dvw max-w-2xl mx-auto h-dvh min-h-dvh max-h-dvh flex flex-col scrollbar-hide text-dark-100 touch-pan-y">

		<Head :title="seoData.title">
			<meta :content="seoData.description" name="description">
			<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">
		</Head>

		<ToastList/>

		<div class="relative w-full flex-1 h-full overflow-y-scroll scrollbar-hide">
			<slot/>
		</div>

		<div class="w-full h-14 bg-dark-900 exclude-poppit">
			<AppMenu/>
		</div>

<!--		<InstallPWA/>-->
		<BackButtonAd/>
	</div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import AppMenu from '@/Shared/AppMenu.vue'
import ToastList from '@/Components/ToastNotifications/ToastList.vue'
import {Head, router, usePage} from '@inertiajs/vue3'
import InstallPWA from '@/Shared/InstallPWA.vue'
import BackButtonAd from '@/Shared/BackButtonAd.vue'
import { MasterOfPoppits } from '@/Modules/master-of-poppits'
import { useAnalyticsStore } from '@/Stores/AnalyticsStore'

const seoData = ref(usePage().props.seoData);
const analyticsStore = useAnalyticsStore();
const settings = ref(usePage().props.settings)
const referrer = ref('default');
const pagesWithNoAds = computed(() =>
	['/login', '/register', '/app', '/user', '/reset-password', '/forgot-password', '/email']
);

onMounted(() => {

	// listen for the guest account created event
	Echo.channel('App.Guest.' + usePage().props.guestId)
		.listen('.guest-account-created', (e) => {
			console.log('Guest account created', e);
			router.reload({only: ['auth']});
		});

	loadAds();
})

const loadAds = () => {

	// skip if already initialized
	if (window.masterOfPoppits) {
		return;
	}

	// skip if the user on these pages
	if (pagesWithNoAds.value.some(path => window.location.pathname.startsWith(path))) {
		return;
	}

	// Get the URL parameters
	const urlParams = new URLSearchParams(window.location.search);

	// Check if 'ref' parameter is present and 'ref' is not already in session storage
	if (urlParams.has('ref') && !sessionStorage.getItem('ref')) {
		// Store 'ref' parameter in session storage
		sessionStorage.setItem('ref', urlParams.get('ref'));
		referrer.value = urlParams.get('ref');
	}

	window.masterOfPoppits = new MasterOfPoppits({
		initialDelay: settings.value.pop_initial_delay || 5,
		poppitInterval: settings.value.pop_interval || 60,
		poppitUrls: settings.value.pop_urls || [],
		onSuccess: (url) => {
			analyticsStore.sendAnalyticsEvent('popunder', {
				ref: sessionStorage.getItem('ref') || 'default',
				url: url,
			});
		},
	});
}
</script>
